// extracted by mini-css-extract-plugin
export default {"messageListItem":"MessageItem_messageListItem__5oYoz","messageAvatar":"MessageItem_messageAvatar__UD5zL","messageListItemContent":"MessageItem_messageListItemContent__NqDG-"};